import { render, staticRenderFns } from "./org.vue?vue&type=template&id=8e188dee&scoped=true&"
import script from "./org.vue?vue&type=script&lang=js&"
export * from "./org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e188dee",
  null
  
)

export default component.exports